/**
 * Created by km arti on 18/07/23.
 */

import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject, Subscription, throwError } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { map, catchError, takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { urls } from './urls';


@Injectable({
    providedIn: 'root'
})
export class DataService {

    // private apiResponseSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    // private apiResponseSource = new EventEmitter<any>();
    // filterClicked = this.apiResponseSource.asObservable();
    // searchFilterChange = new Subject<any>();
    // private viewProductResponseSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    // public viewProductResponse$: Observable<any> = this.viewProductResponseSubject.asObservable();
    // private viewProductResponseSubject = new BehaviorSubject<any>(null);
    // viewProductResponse$ = this.viewProductResponseSubject.asObservable();

    private searchFilterChangeSubject = new BehaviorSubject<any>(null);
    searchFilterChange$: Observable<any> = this.searchFilterChangeSubject.asObservable();
    private destroy$: Subject<void> = new Subject<void>(); // Subject to handle subscription cleanup
    private isLoggingOut = false;


    viewProductResponse = {};

    setSelectedCountryName(selectedCountryName) {
        localStorage.setItem('selectedCountryName', selectedCountryName);
    }
    setSelectedCountryCode(selectedCountryCode) {
        localStorage.setItem('selectedCountryCode', selectedCountryCode);
    }

    constructor(private http: HttpClient, private router: Router) {


    }

    onSpinner() {
        const spinner = <HTMLDivElement>document.getElementById('curtain-spinner');
        const curtain = <HTMLDivElement>document.getElementById('curtain');
        spinner.style.display = 'block';
        curtain.style.display = 'block';
    }

    offSpinner() {
        const spinner = <HTMLDivElement>document.getElementById('curtain-spinner');
        const curtain = <HTMLDivElement>document.getElementById('curtain');
        spinner.style.display = 'none';
        curtain.style.display = 'none';
    }


    callRestful(type: string, url: string, body?: any, headerObject?: any, includeHeader?: boolean, params?: HttpParams, hideSpinner?: boolean): Observable<any> {
        if (!(hideSpinner != null && hideSpinner == false)) {
            this.onSpinner();
        }

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        if (headerObject) {
            Object.keys(headerObject).forEach(key => {
                headers = headers.set(key, headerObject[key]);
            });
        }

        const token = this.getToken();
       
        if(token && url.includes(urls.gateway_domain) && !headers.has('Authorization')) {
            headers = headers.set('Authorization', `Bearer ${token}`);
        }

        let request$: Observable<any>;
        const requestType = (type || 'GET').toUpperCase();

        switch (requestType) {
            case 'GET':
            case 'GET_MSN':
                request$ = this.http.get(url, { headers, params, responseType: 'json' });
                break;
            case 'JSON':
                request$ = this.http.get(url, { params, responseType: 'text' as 'json' });
                break;
            case 'POST':
                request$ = this.http.post<any>(url, body, { headers, params });
                break;
            case 'PUT':
                request$ = this.http.put<any>(url, body, { headers, params });
                break;
            case 'PATCH':
                request$ = this.http.patch<any>(url, body, { headers, params });
                break;
            case 'DELETE':
                request$ = this.http.delete<any>(url, { headers, params });
                break;
            default:
                request$ = this.http.get(url, { headers, params, responseType: 'json' });
                break;
        }

        return request$.pipe(
            catchError((err) => {
                this.offSpinner();
                return throwError(err);
            })
        );
    }

    handleGlobalHttpError(error: any) {
        this.offSpinner();
        if (!error) {
            this.showMessage('error', 'An unknown error occurred.');
            return;
        }

        const status = error.status;
        switch (status) {
            case 401:
                this.handleUnauthorizedError('Unauthorized access or session expired. Logging out...');
                break;
            case 403:
                this.handleUnauthorizedError('Access forbidden (403). Logging out...');
                break;
            case 404:
                this.showMessage('error', 'Requested resource not found (404).');
                break;
            case 500:
                this.showMessage('error', 'Internal server error (500). Please try again later.');
                break;
            case 502:
            case 503:
            case 504:
                this.showMessage('error', 'Service temporarily unavailable. Please try again later.');
                break;
            case 0:
                this.showMessage('error', 'Network connection error. Please check your network connection.');
                break;
            default:
                if (error && error.message) {
                    this.showMessage('error', error.message);
                } else {
                    this.showMessage('error', 'An error occurred while processing your request.');
                }
                break;
        }
    }


    showMessage(cssClass, msg) {

        const x = document.getElementById('alert-box');
        if (document.getElementById('paraText') != null) {
            x.removeChild(document.getElementById('paraText'));
        }
        const para = document.createElement('span');
        para.setAttribute('id', 'paraText');
        para.innerHTML = msg;
        let classType = '';
        x.appendChild(para);
        if (cssClass === 'error') {
            classType = 'show-error';
        }
        if (cssClass === 'success') {
            classType = 'show-sucess';
        }
        if (cssClass === 'info') {
            classType = 'show-info';
        }
        if (cssClass === 'downloadMSG') {
            classType = 'show-downloadMSG';
        }
        x.className = classType;
        setTimeout(function () {
            x.className = x.className.replace(classType, '');
        }, 5000);
    }

    // session storage
    createSession(userId, email, token) {
        const pass = 'pass';
        localStorage.setItem('email', email);
        localStorage.setItem('userId', userId);
        localStorage.setItem('token', token);
    }
    page1SelectedCagtegoy() {
        return JSON.parse(localStorage.getItem('page1slectedCategory'))
    }

    getToken() {
        return localStorage.getItem('token');
    }

    getSelectedCountryCode() {
        return JSON.parse(localStorage.getItem('selectedCountryCode'));
    }

    getSelectedCountryName() {
        return (localStorage.getItem('selectedCountryName'));

    }

    getSelectedBusinessDisplayName() {
        return localStorage.getItem('selectedParentBusinessDisplayName');
    }

    setSelectedParentBusinessCode(parentBusinessCode: string) {
        localStorage.setItem('selectedParentBusinessCode', parentBusinessCode);
    }

    getSelectedParentBusinessCode() {
        return localStorage.getItem('selectedParentBusinessCode');
    }

    setSelectedBusinessDisplayName(selectedBusinessCode) {
        localStorage.setItem('selectedParentBusinessDisplayName', selectedBusinessCode);
    }

    getSelectedRootCategory() {
        return localStorage.getItem('selectedParentBusiness');
    }

    getCountryList() {
        return JSON.parse(localStorage.getItem('countryList'));
    }

    setCountryList(countryList: any) {
        localStorage.setItem('countryList', JSON.stringify(countryList));

    }

    setSelectedCategoryCode(categoryCode) {
        localStorage.setItem('selectedCategoryCode', categoryCode);
    }

    getSelectedCategoryCode() {
        return localStorage.getItem('selectedCategoryCode');
    }

    setSelectedBrandId(brandId) {
        localStorage.setItem("selectedBrandId", brandId);
    }

    getSelectedBrandId() {
        return localStorage.getItem('selectedBrandId');
    }

    setSelectedBrandName(brandName) {
        localStorage.setItem('brandName', brandName)
    }

    getSelectedBrandName() {
        return localStorage.getItem('brandName');
    }

    setSelectedGroupId(groupId) {
        localStorage.setItem('selectedGroupId', groupId);
    }

    getSelectedGroupId() {
        return localStorage.getItem('selectedGroupId');
    }

    destorySession() {
        // localStorage.removeItem("email");
        // localStorage.removeItem("name");
        localStorage.clear();
    }

    logout() {
        if (this.isLoggingOut) {
            return;
        }
        this.isLoggingOut = true;
        this.onSpinner();

        const logoutUrl = urls.catalogUserLogout;
        const email = this.getEmail();
        const token = this.getToken();

        const body = {
            userEmail: email,
            jwtToken: token,
            domainType: 'ECS'
        };

        const performSessionCleanup = () => {
            this.destorySession();
            this.offSpinner();
            this.isLoggingOut = false;
            this.router.navigateByUrl('/login').then(() => {
                window.localStorage.setItem('logged_in', 'false');
            });
        };

        if (logoutUrl) {
            this.http.post(logoutUrl, body).subscribe(
                (response: any) => {
                    console.log('Catalog Logout API Success', response);
                    performSessionCleanup();
                },
                (error) => {
                    console.error('Catalog Logout API Error', error);
                    performSessionCleanup();
                }
            );
        } else {
            performSessionCleanup();
        }
    }

    handleUnauthorizedError(msg?: string) {
        const errorMsg = msg || 'Unauthorized access or session expired. Logging out...';
        this.showMessage('error', errorMsg);
        this.logout();
    }

    getEmail() {
        return localStorage.getItem('email');
    }


    setviewProductResponse(productveiwData) {

        this.viewProductResponse = productveiwData;


    }
    getviewProductResponse() {
        return this.viewProductResponse
    }

    getviewHeaderTemplate() {
        return this.viewProductResponse["data"]["viewHeaderTemplate"];
    }
    getattributeFilterBuckets() {
        return this.viewProductResponse["data"]["attributeFilterBuckets"];
    }

    getproductList() {
        return this.viewProductResponse["data"]["products"];
    }
    getCategoryL1List(data) {
        const url = urls.categoryL1;
        return this.callRestful('POST', url, data);
    }
    getCategoryList(searchedCategories) {

        const categoryList: any = {};

        Object.keys(searchedCategories).forEach((categoryId) => {
            const categoryData = searchedCategories[categoryId];
            categoryList[categoryId] = {
                categoryName: categoryData.categoryName,
                productCount: categoryData.productCount,
            };
        });
        return categoryList;
    }
    getSearchedCategoryAPI(request) {
        let url = urls.platformdatprod + 'cassandraFeed/catalogCategory/categorySearch';
        return this.callRestful('POST', url, request);
    }
    getSearchedBrandAPI(request) {
        let url = urls.searchBrand + 'search/brands?pageNo=1&pageSize=1';

        const token = localStorage.getItem('token');

        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        });

        let data = this.http.post(url, request, { headers }).pipe(
            catchError((error) => {
                this.offSpinner()
                this.showMessage("error", "Something went wrong with current request. Please try again later.")
                return throwError('Something went wrong with current request. Please try again later.');
            })
        );
        return data;

    }


    getBreadCrumData(categoryID) {
        const url = urls.catalog + 'mapper/parentHierarchy?categoryCode=' + categoryID;
        return this.callRestful('GET', url, null, null, null, null, false);
    }
    // Method to get the product view API data
    getProductViewAPI(url, request: any): Observable<any> {
        return this.callRestful('POST', url, request);
    }

    getAccordainAPIdata(categoryID) {
        const apiAccordain = urls.platformdatprod + 'cassandraFeed/category/getByCode?code=' + categoryID;
        return this.callRestful('GET', apiAccordain);
    }

    // Simulate API call with search text input
    simulateAPICall(searchText): Promise<any> {
        let apiUrl = urls.search + 'search/brands';

        const headers = new HttpHeaders().set('Authorization', 'your_api_key');
        //const body = { inputsearchString: searchText };

        return this.http.post(apiUrl, searchText).toPromise();

    }


    // Method to emit the search filter change only when the data changes
    emitSearchFilterChange(data: any): void {
        if (data !== this.searchFilterChangeSubject.getValue()) {
            this.searchFilterChangeSubject.next(data);
        }
    }




    // Method to clear the subscription and prevent memory leaks
    clearSubscription(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    catchThis(err) {
        this.offSpinner();
        if (err.message) {
            this.showMessage('error', "Event Tracker Failed...");
            //alert("Error occurred, " + err.message + " try after some time");
        } else {
            this.showMessage('error', 'Network error accouured');
            //alert("Network error accouured");
        }
    }
    eventTracker(eventSource: string, eventType: string, data: string, pageUrl: string) {
        let url: string = urls.eventTracker;
        let body = {
            "userId": this.getEmail(),
            "eventSource": eventSource.toUpperCase(),
            "eventType": eventType,
            "data": data,
            "pageUrl": pageUrl
        }



        this.callRest('POST', url, body, null, null, null, false).subscribe((data => {

            if (data.status) {
                console.log(eventType + " Event published successfully");
            } else {
                this.showMessage("error", "Event Tracker Failed...");
                console.log("Publishing " + eventType + " Event  failed");
            }
        }))



    }
    callRest(type: string, url: string, body?: any, headerObject?: any, includeHeader?: boolean, params?: HttpParams, hideSpinner?: boolean) {
        return this.callRestful(type, url, body, headerObject, includeHeader, params, hideSpinner);
    }

}
